import React from 'react';
import { useGoalHierarchyQuery } from '../../../../../__generated__/graphql';
import { GoalId } from '../../types';
import { toObjectiveIdInput } from '../../mappings';
import { mapGoalHierarchy } from './mappings';
import { GoalHierarchy, GoalHierarchyLoading } from './GoalHierarchy';

type Props = {
  goalId: GoalId;
  onLinkClick?: () => void;
};

export const GoalHierarchyConnected: React.FC<
  React.PropsWithChildren<Props>
> = ({ goalId, onLinkClick }) => {
  const { data, loading, error } = useGoalHierarchyQuery({
    variables: {
      objectiveId: toObjectiveIdInput(goalId),
    },
  });

  if (loading) {
    return <GoalHierarchyLoading />;
  }

  if (error || !data?.objective) {
    return null;
  }

  const rootGoal = mapGoalHierarchy(data.objective);

  return (
    <GoalHierarchy
      rootGoal={rootGoal}
      currentGoalId={goalId.id}
      onLinkClick={onLinkClick}
    />
  );
};
